module.exports = __webpack_public_path__ + "img/8.be74add6.jpg";